import { render, staticRenderFns } from "./RmaApprovalModal.vue?vue&type=template&id=9b2e4aba"
import script from "./RmaApprovalModal.vue?vue&type=script&lang=js"
export * from "./RmaApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports